import { render, staticRenderFns } from "./NewUploader2.vue?vue&type=template&id=05d9ef17&"
import script from "./NewUploader2.vue?vue&type=script&lang=ts&"
export * from "./NewUploader2.vue?vue&type=script&lang=ts&"
import style0 from "./NewUploader2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports